export default __webpack_public_path__ + "static/watchdog-6c2f5a583128dee2d801bff8227357af.svg";